import React, { useState, useEffect } from 'react';
import { Typography, Box, Rating, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import {
    TestimonialsContainer,
    TestimonialCard,
    TestimonialContent,
    TestimonialAuthor,
    TestimonialNavigation,
    QuoteIcon,
} from './Testimonials.styles';
import axios from 'axios';

const backendUrl =
    import.meta.env.MODE === 'development'
        ? `http://${import.meta.env.VITE_BACKEND_URL}`
        : `https://${import.meta.env.VITE_BACKEND_URL_PROD}`;

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const fetchTestimonials = async () => {
            try {
                const response = await axios.get(`${backendUrl}/testimonials`);
                const approvedTestimonials = response.data.filter(
                    (testimonial) => testimonial.approved === true
                );
                setTestimonials(approvedTestimonials);
            } catch (error) {
                console.error('Error fetching testimonials:', error);
            }
        };

        fetchTestimonials();
    }, []);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : testimonials.length - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex < testimonials.length - 1 ? prevIndex + 1 : 0
        );
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                height: 'auto',
                py: { xs: 8, md: 12 },
            }}
        >
            <TestimonialsContainer id="testimonials">
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    color="text.primary"
                    gutterBottom
                    sx={{ fontWeight: 600, mb: 6 }}
                >
                    Customer Testimonials
                </Typography>

                <Typography
                    variant="h5"
                    align="center"
                    color="text.secondary"
                    sx={{ mb: 8, maxWidth: '800px', mx: 'auto' }}
                >
                    Don't just take our word for it. Here's what our customers
                    have to say about our services.
                </Typography>
                {console.log(testimonials)}
                {testimonials.length > 0 && (
                    <Box
                        sx={{
                            position: 'relative',
                            maxWidth: '900px',
                            mx: 'auto',
                        }}
                    >
                        <TestimonialCard>
                            <QuoteIcon>
                                <FormatQuoteIcon fontSize="large" />
                            </QuoteIcon>
                            <TestimonialContent>
                                <Typography variant="body1" paragraph>
                                    {testimonials[currentIndex].content}
                                </Typography>
                                <Rating
                                    value={testimonials[currentIndex].rating}
                                    readOnly
                                    precision={0.5}
                                    sx={{ mb: 2 }}
                                />
                                <TestimonialAuthor>
                                    <Typography variant="h6" component="p">
                                        {testimonials[currentIndex].name}
                                    </Typography>
                                </TestimonialAuthor>
                            </TestimonialContent>
                        </TestimonialCard>

                        <TestimonialNavigation>
                            <IconButton onClick={handlePrev} color="primary">
                                <ArrowBackIosNewIcon />
                            </IconButton>
                            <Box sx={{ mx: 2 }}>
                                {currentIndex + 1} / {testimonials.length}
                            </Box>
                            <IconButton onClick={handleNext} color="primary">
                                <ArrowForwardIosIcon />
                            </IconButton>
                        </TestimonialNavigation>
                    </Box>
                )}
            </TestimonialsContainer>
        </Box>
    );
};

export default Testimonials;
